module.exports = __webpack_public_path__ + "static/media/maplayer_1_3_1_a1c.1a2cd945.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/03/assets/maplayer_1_3_1_a1c.svg
// module id = 784
// module chunks = 0